define(function(require, exports, module) {
    'use strict';
    var _ = require('underscore');
    var PopupView = require('modules/popup/popup.view');
    var LimitsPopupView = require('portlets/responsible-gaming/limits/limits.popup.view');

    module.exports = {

        /**
         * @param {object} options
         **/
        notify: function(options) {
            var lossLimitPopup = _.find(PopupView.popups, function(popup) {
                return popup.$el.hasClass('popup_type_loss_limit');
            });

            lossLimitPopup || new LimitsPopupView(options.data);
        }

    };
});
